export const uploadFileUsingPresignedUrl = async (
  presignedUrl,
  selectedFile,
) => {
  const response = await fetch(presignedUrl, {
    method: 'PUT',
    body: selectedFile,
    headers: {
      'Content-Type': selectedFile.type,
    },
  });
  // const response = await axios.put(signedUrl, selectedFile);
  return response.status === 200;
};

export const splitNameFromUrl = (url) => {
  if (!url) return '';
  const extractNameFromUrl = url.split('/');
  if (extractNameFromUrl.length)
    return extractNameFromUrl[extractNameFromUrl.length - 1];
  return url;
};
